import React from 'react';
import QueryStringService from '../../services/queryStringService.js';

const bg1seplay = require('../../images/bg1seplay.jpg');
const bg2seplay = require('../../images/bg2seplay.jpg');
const bg3seplay = require('../../images/bg3seplay.jpg');
const bg1seposting = require('../../images/bg1seposting.jpg');
const bg2seposting = require('../../images/bg2seposting.jpg');
const bg3seposting = require('../../images/bg3seposting.jpg');

const bg1noplay = require('../../images/bg1noplay.jpg');
const bg2noplay = require('../../images/bg2noplay.jpg');
const bg3noplay = require('../../images/bg3noplay.jpg');
const bg1noposting = require('../../images/bg1noposting.jpg');
const bg2noposting = require('../../images/bg2noposting.jpg');
const bg3noposting = require('../../images/bg3noposting.jpg');

const bg1dkplay = require('../../images/bg1dkplay.jpg');
const bg2dkplay = require('../../images/bg2dkplay.jpg');
const bg3dkplay = require('../../images/bg3dkplay.jpg');
const bg1dkpostingA = require('../../images/bg1dkpostingAdshel.jpg');
const bg2dkpostingA = require('../../images/bg2dkpostingAdshel.jpg');
const bg3dkpostingA = require('../../images/bg3dkpostingAdshel.jpg');
const bg1dkpostingG3 = require('../../images/bg1dkpostingAdshel_group_of_3.jpg');
const bg2dkpostingG3 = require('../../images/bg2dkpostingAdshel_group_of_3.jpg');
const bg3dkpostingG3 = require('../../images/bg3dkpostingAdshel_group_of_3.jpg');

export default class BackgroundImage extends React.Component {
    constructor(props) {
        super(props);

        this.queryStringService = new QueryStringService();
        this.country = this.queryStringService.getCurrentCountry();
        this.state = {
        };
    }

    componentDidMount() {
    }

    componentDidUpdate() {
    }

    getPostingImageSourceDK(bg) {
        let imgSource = bg1dkpostingA;
        let imgClass = 'bg1dkpostingA';
        let a = 'CP02';
        switch (this.props.packageType) {
            case 'CP02':
                imgSource = bg === 1 ? bg1dkpostingG3 : bg === 2 ? bg2dkpostingG3 : bg3dkpostingG3;
                imgClass = bg === 1 ? 'bg1dkpostingG3' : bg === 2 ? 'bg2dkpostingG3' : 'bg3dkpostingG3';
                break;

            default:
                imgSource = bg === 1 ? bg1dkpostingA : bg === 2 ? bg2dkpostingA : bg3dkpostingA;
                imgClass = bg === 1 ? 'bg1dkpostingA' : bg === 2 ? 'bg2dkpostingA' : 'bg3dkpostingA';
                break;
        }

        return { source: imgSource, class: imgClass}
    }

    render() {
        let bg = Math.floor(Math.random() * 3) + 1;
        let country = 'se';
        if (this.country !== null && this.country !== '')
        {
            country = this.country;
        }
        let imgClass = 'bg' + bg + country + this.props.campaignType;
        let imgSource = bg1seplay;
        switch (country) {
            case 'se':
                if (this.props.campaignType === 'play') {
                    imgSource = bg === 1 ? bg1seplay : bg === 2 ? bg2seplay : bg3seplay;
                } else {
                    imgSource = bg === 1 ? bg1seposting : bg === 2 ? bg2seposting : bg3seposting;
                }
                break;

            case 'no':
                if (this.props.campaignType === 'play') {
                    imgSource = bg === 1 ? bg1noplay : bg === 2 ? bg2noplay : bg3noplay;
                } else {
                    imgSource = bg === 1 ? bg1noposting : bg === 2 ? bg2noposting : bg3noposting;
                }
                break;

            case 'dk':
                if (this.props.campaignType === 'play') {
                    imgSource = bg === 1 ? bg1dkplay : bg === 2 ? bg2dkplay : bg3dkplay;
                } else {
                    let img = this.getPostingImageSourceDK(bg);
                    imgSource = img.source;
                    imgClass = img.class;
                }
                break;

            default: imgSource = bg1seplay;
        }
        return (
            <div className={"container campaign-info-bg " + imgClass}>
                <img src={imgSource} width="100%" />
            </div>
        );
    }
}